import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";

// Pages
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PersonnelRequestPage from "@/pages/PersonnelRequestPage";
import JobApplicationPage from "@/pages/JobApplicationPage";
import BelgelerimizPage from "@/pages/BelgelerimizPage";
import ReferanslarimizPage from "@/pages/ReferanslarimizPage";
import BizdenHaberlerPage from "@/pages/BizdenHaberlerPage";
import SubmissionsPage from "@/pages/SubmissionsPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminContent from "@/pages/admin/AdminContent";
import AdminSiteSettings from "@/pages/admin/AdminSiteSettings";
import AdminMediaGallery from "@/pages/admin/AdminMediaGallery";
import AdminJobApplications from "@/pages/admin/AdminJobApplications";
import AdminPersonnelRequests from "@/pages/admin/AdminPersonnelRequests";

// Context
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <div className="App min-h-screen">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/hizmetler" element={<ServicesPage />} />
            <Route path="/hizmetler/:slug" element={<ServiceDetailPage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/belgelerimiz" element={<BelgelerimizPage />} />
            <Route path="/referanslarimiz" element={<ReferanslarimizPage />} />
            <Route path="/haberler" element={<BizdenHaberlerPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/personel-talep" element={<PersonnelRequestPage />} />
            <Route path="/is-basvurusu" element={<JobApplicationPage />} />
            
            {/* Secret submissions viewer - noindex */}
            <Route path="/basvurular/:token" element={<SubmissionsPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/categories" element={<ProtectedRoute><AdminCategories /></ProtectedRoute>} />
            <Route path="/admin/messages" element={<ProtectedRoute><AdminMessages /></ProtectedRoute>} />
            <Route path="/admin/content" element={<ProtectedRoute><AdminContent /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSiteSettings /></ProtectedRoute>} />
            <Route path="/admin/media" element={<ProtectedRoute><AdminMediaGallery /></ProtectedRoute>} />
            <Route path="/admin/job-applications" element={<ProtectedRoute><AdminJobApplications /></ProtectedRoute>} />
            <Route path="/admin/personnel-requests" element={<ProtectedRoute><AdminPersonnelRequests /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
